import React, { useEffect } from "react";
import CollectionSubCategies from "features/collection/components/SubCategoryScreen/collectionSubCategory.jsx";
import SortContext from "context/SortContext";
import { useLocation } from "react-router-dom";

const CollectionSubCategyPage = () => {
  const location = useLocation();

  const { setSortOptions, setSelectedSortValue, setSearch, search } = React.useContext(SortContext);

  React.useEffect(() => {
    setSearch("");
    setSortOptions([
      { id: 1, name: "Alphabetical Quote (A to Z)", sortBy: "alphabetical", order: "asc" },
      { id: 2, name: "Alphabetical Quote (Z to A)", sortBy: "alphabetical", order: "desc" },
      { id: 3, name: "Design Quantity (High to Low)", sortBy: "quantity", order: "desc" },
      { id: 4, name: "Design Quantity (Low to High)", sortBy: "quantity", order: "asc" },
    ]);

    return () => {
      setSortOptions([]);
      setSelectedSortValue(null);
      setSearch("");
    };
  }, []);

  useEffect(() => {
    setSearch(location?.state?.subCatgeorySearch || "");
  }, [location]);

  return <CollectionSubCategies />;
};

export default CollectionSubCategyPage;
